module.exports = {"currency":"R$","total":"Total"}


//////////////////
// WEBPACK FOOTER
// ./src/app/elements/InvoiceDetailsHeaderAmount/data.json
// module id = 2087
// module chunks = 0